// extracted by mini-css-extract-plugin
module.exports = {"name":"totalcount_name__3GFiP","count":"totalcount_count__emla5"};